import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Loadable } from "components/support";
import Items from "./items";

class KitInfoView extends Component {
  render() {
    const { items, loading } = this.props.viewModel;

    return (
      <div className="grid-container">
        <Loadable loading={loading}>
          <Row>
            <Col xs={12}>
              {items.map(item => (
                <Items key={item.uuid} item={item} />
              ))}
            </Col>
          </Row>
        </Loadable>
      </div>
    );
  }
}

export default KitInfoView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/kit-info/view.jsx